// src/components/support/forms/Contact.js
import React from 'react';
import { ChevronLeft, MessageCircle, FileText, Phone } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';

const Contact = () => {
    const location = useLocation();
    const navigate = useNavigate()

    const handleBack = () => {
        if (location.state?.from) {
            navigate(location.state.from); // go back to origin
        } else {
            navigate(-1); // fallback
        }
    };
    return (
        <div className="fixed inset-0 bg-gray-50 z-50 overflow-y-auto">
            <div className="sticky top-0 bg-white border-b p-4 flex items-center space-x-3">
                <button onClick={handleBack}>
                    <ChevronLeft className="w-6 h-6 text-gray-600" />
                </button>
                <h2 className="text-lg font-bold text-gray-800 cursor-pointer" onClick={handleBack}>Contact Us</h2>
            </div>

            <div className="p-4 space-y-3">
                {/* <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 text-center">
                    <MessageCircle className="w-12 h-12 text-cyan-500 mx-auto mb-3" />
                    <h3 className="font-bold text-gray-800 mb-2">Chat Now</h3>
                    <p className="text-sm text-gray-600 mb-4">Get instant support via chat</p>
                    <button onClick={() => navigate('/chat')} className="w-full bg-cyan-500 text-white py-3 rounded-xl font-semibold hover:bg-cyan-600 transition">
                        Start Chat
                    </button>
                </div> */}

                <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 text-center">
                    <FileText className="w-12 h-12 text-purple-500 mx-auto mb-3" />
                    <h3 className="font-bold text-gray-800 mb-2">Open Ticket</h3>
                    <p className="text-sm text-gray-600 mb-4">Submit a support ticket</p>
                    <button onClick={() => navigate('/raise')} className="w-full bg-purple-500 text-white py-3 rounded-xl font-semibold hover:bg-purple-600 transition">
                        Create Ticket
                    </button>
                </div>
                {/* 
                <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 text-center">
                    <Phone className="w-12 h-12 text-green-500 mx-auto mb-3" />
                    <h3 className="font-bold text-gray-800 mb-2">Call Now</h3>
                    <p className="text-sm text-gray-600 mb-4">Speak with our support team</p>
                    <a href="tel:+911234567890" className="block w-full bg-green-500 text-white py-3 rounded-xl font-semibold hover:bg-green-600 transition">
                        Call +91 123-456-7890
                    </a>
                </div> */}
            </div>
        </div>
    );
};

export default Contact;